import { api } from './api';
import { endpoints } from './endpoints';

export const services = {
  getPopularGifts: params =>
    api.get(endpoints.getPopularGifts, { params }).then(res => res.data.data),
  getAcceptanceRate: (code, params) =>
    api.get(endpoints.getAcceptanceRate(code), { params }).then(res => res.data.data),
  orders: params => api.get(endpoints.orders(), { params }).then(res => res.data.data),
  sendGiftCardEmail: code => api.post(endpoints.sendGiftCardEmail(code)).then(res => res.data.data),
  getThankYouNotes: params =>
    api.get(endpoints.thankYouNotes(), { params }).then(res => res.data.data),
  getDashboardSummary: params =>
    api.get(endpoints.dashboardSummary(), { params }).then(res => res.data.data),
  getGraphData: params => api.get(endpoints.getGraphData(), { params }).then(res => res.data.data)
};
